var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState, forwardRef, useImperativeHandle } from 'react';
import { Paper, Table, TableContainer } from '@mui/material';
import BaseTableLoading from '@libs/@core/components/table/BaseTableLoading';
import BaseTableNoData from '@libs/@core/components/table/BaseTableNoData';
import BaseTableBody from '@libs/@core/components/table/BaseTableBody';
import BaseTableHead from '@libs/@core/components/table/BaseTableHead';
import BasePagination from '@libs/@core/components/table/BasePagination';
/**
 *
 * @param data Dữ liệu của bảng
 *
 * @param columns Các cột của bảng
 *
 * @param pagination Phân trang
 *
 * @param checkedIndex Key của dữ liệu được chọn
 *
 * @param hasCheckBox Hiển thị checkbox
 *
 * @param isLoading Đang tải dữ liệu
 *
 * @param headerStyle Style của header
 *
 * @param bodyStyle Style của body
 *
 * @param ordinalNumber Hiển thị số thứ tự
 *
 * @param actions Hành động
 *
 * @param {function} handleCheckRowId Callback khi chọn dữ liệu - return boolean
 *
 * @returns
 */
var BaseTable = function (props, ref) {
    var data = props.data, columns = props.columns, pagination = props.pagination, checkedIndex = props.checkedIndex, _a = props.hasCheckBox, hasCheckBox = _a === void 0 ? true : _a, isLoading = props.isLoading, customStyle = props.customStyle, headerStyle = props.headerStyle, bodyStyle = props.bodyStyle, ordinalNumber = props.ordinalNumber, actions = props.actions, handleCheckRowId = props.handleCheckRowId;
    var _b = useState([]), listSelected = _b[0], setListSelected = _b[1];
    useImperativeHandle(ref, function () { return ({
        handleSelectRow: function (id) {
            if (!id)
                return;
            var selectedIndex = listSelected.indexOf(id);
            if (selectedIndex === -1) {
                setListSelected(__spreadArray(__spreadArray([], listSelected, true), [id], false));
            }
            else {
                setListSelected(listSelected.filter(function (n) { return n !== id; }));
            }
        },
        handleSeleteIdList: function (ids) {
            console.log(ids);
            setListSelected(ids);
        }
    }); });
    var handleSelectdAllClick = function () {
        if (listSelected.length === ((pagination === null || pagination === void 0 ? void 0 : pagination.totalElements) || data.length) || !checkedIndex) {
            setListSelected([]);
            return;
        }
        var newSelecteds = data.map(function (n) { return n[checkedIndex]; });
        if (typeof handleCheckRowId === 'undefined') {
            setListSelected(newSelecteds);
            return;
        }
        var _handleCheckRowId = handleCheckRowId(newSelecteds);
        if (_handleCheckRowId === undefined) {
            setListSelected(newSelecteds);
        }
        if (_handleCheckRowId) {
            setListSelected(newSelecteds);
        }
    };
    var handleSelectRow = function (id) {
        if (!id)
            return;
        var selectedIndex = listSelected.indexOf(id);
        var newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(listSelected, id);
        }
        else if (selectedIndex === 0) {
            newSelected = newSelected.concat(listSelected.slice(1));
        }
        else if (selectedIndex === listSelected.length - 1) {
            newSelected = newSelected.concat(listSelected.slice(0, -1));
        }
        else if (selectedIndex > 0) {
            newSelected = newSelected.concat(listSelected.slice(0, selectedIndex), listSelected.slice(selectedIndex + 1));
        }
        if (typeof handleCheckRowId === 'undefined') {
            setListSelected(newSelected);
            return;
        }
        var _handleCheckRowId = handleCheckRowId(newSelected);
        if (_handleCheckRowId === undefined) {
            setListSelected(newSelected);
        }
        if (_handleCheckRowId) {
            setListSelected(newSelected);
        }
    };
    var contentTableBody = useMemo(function () {
        var numberColumns = columns.length;
        if (hasCheckBox) {
            numberColumns += 1;
        }
        if (ordinalNumber) {
            numberColumns += 1;
        }
        if (isLoading) {
            return _jsx(BaseTableLoading, { columns: columns, hasCheckBox: hasCheckBox, ordinalNumber: ordinalNumber });
        }
        if (data.length === 0) {
            return _jsx(BaseTableNoData, { numberColumns: numberColumns });
        }
        return (_jsx(BaseTableBody, { data: data, columns: columns, ordinalNumber: ordinalNumber, hasCheckBox: hasCheckBox, checkedIndex: checkedIndex, listSelected: listSelected, customStyle: bodyStyle, handleSelectRow: handleSelectRow, actions: actions }));
    }, [actions, ordinalNumber, checkedIndex, columns, data, hasCheckBox, isLoading, listSelected]);
    return (_jsxs(Paper, { sx: { width: '100%', background: 'transparent' }, children: [_jsx(TableContainer, { ref: ref, sx: __assign({ width: 'inherit', maxHeight: '400px', position: 'relative' }, (customStyle && __assign({}, customStyle))), children: _jsxs(Table, { stickyHeader: true, "aria-label": 'simple table', children: [_jsx(BaseTableHead, { isLoading: isLoading, columns: columns, hasCheckBox: hasCheckBox, ordinalNumber: ordinalNumber, customStyle: headerStyle, indeterminate: listSelected.length > 0 && listSelected.length < ((pagination === null || pagination === void 0 ? void 0 : pagination.totalElements) || data.length), checked: !!data.length && !!(listSelected.length === ((pagination === null || pagination === void 0 ? void 0 : pagination.totalElements) || data.length)), handleSelectdAllClick: handleSelectdAllClick }), contentTableBody] }) }), pagination && (_jsx(BasePagination, { page: (pagination === null || pagination === void 0 ? void 0 : pagination.page) || 1, limit: (pagination === null || pagination === void 0 ? void 0 : pagination.limit) || 10, totalPage: (pagination === null || pagination === void 0 ? void 0 : pagination.totalPage) || 1, handleChangePagination: pagination === null || pagination === void 0 ? void 0 : pagination.handleChangePagination }))] }));
};
BaseTable.displayName = 'BaseTable';
export default forwardRef(BaseTable);
